document.addEventListener("DOMContentLoaded", function () {
  const root = document.querySelector(".story-cards");
  if (!root) return;


  root.querySelectorAll("[data-toggle]").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();

      const item = btn.closest(".story-cards__item");
      if (!item) return;

      const overlay = item.querySelector("[data-overlay]");
      const title = item.querySelector(".story-cards__title");

        // root.querySelectorAll(".story-cards__item.is-open").forEach((openItem) => {
        //   if (openItem !== item) {
        //     openItem.classList.remove("is-open");

        //     const otherTitle = openItem.querySelector(".story-cards__title");
        //     if (otherTitle) otherTitle.style.display = "";
        //   }
        // });
      

      item.classList.toggle("is-open");

      if (title) {
        if (item.classList.contains("is-open")) {
          title.style.display = "none";
        } else {
          title.style.display = "";
        }
      }
    });
  });
});